import { ThemeProvider } from '@mea-menu/components'
import { ErrorBoundary } from 'react-error-boundary'
import { Platform, View } from 'react-native'
import { RootSiblingParent } from 'react-native-root-siblings'
import { Browser as SentryBrowser, init as SentryInit } from 'sentry-expo'
import 'setimmediate'
import { AppLoader, ErrorPage, NotificationManager } from './src/components'
import { config } from './src/config'
import './src/localization'
import { AppNavigator } from './src/navigation/Navigator'
import { useThemeStore } from './src/store'
import { WEB_APP_MAX_WIDTH_PX } from './src/theme/sizes'
import { MeaError } from './src/types'

// Sentry config
SentryInit({
  dsn: 'https://4641912d83bb46bc13c13a21af3e56f5@o1185289.ingest.sentry.io/4506213785927680',
  release: `mea-menu-manager:v${config.version}`,
  enableInExpoDevelopment: false,
  debug: __DEV__,
  enabled: config.environment === 'prod',
  tracesSampleRate: 0.8,
})

const onError = async (error: Error) => {
  if (Platform.OS === 'web') {
    SentryBrowser.captureException(error)
  }
  if (error instanceof MeaError && error.fatal) {
    localStorage.clear()
  }
}

const App = () => {
  const { colorMode } = useThemeStore()
  return (
    <View style={{ flex: 1, justifyContent: 'center', flexDirection: 'row' }}>
      <View style={{ flex: 1, maxWidth: WEB_APP_MAX_WIDTH_PX }}>
        <RootSiblingParent>
          <ErrorBoundary
            onError={onError}
            FallbackComponent={({ error, resetErrorBoundary }) => {
              return <ErrorPage error={error} resetErrorBoundary={resetErrorBoundary} />
            }}
          >
            <ThemeProvider theme={colorMode}>
              <NotificationManager />
              <AppLoader>
                <AppNavigator />
              </AppLoader>
            </ThemeProvider>
          </ErrorBoundary>
        </RootSiblingParent>
      </View>
    </View>
  )
}

export default App
